import {
  orderHubPosModule,
  paymentPosModule,
  tableLayoutPosModule,
  dashboardPosModule,
} from '../PosModules/moduleFeatures';
import {
  integrationModulePermissions,
  menuBoardPermission,
  payrollModulePermissions,
  reviewManagementFeaturePermission,
  roleAndPermissionsModulePermissions,
  settingsModulePermission,
  settingsPosFeaturePermissions,
  tenderCashDrawerFeatures,
  tipsPoolingModulePermissions,
  visibleCheckPermissions,
} from './DashboardPermissions';

export const defaultOwnerPermission = [
  {
    id: 1,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 4,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 5,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 6,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 7,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 8,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 7,
    featureId: null,
    key: 'roles-permissions-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 9,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 8,
    featureId: null,
    key: 'orders-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 10,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 9,
    featureId: null,
    key: 'hiring-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 11,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: null,
    key: 'restaurant-configurations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 12,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 13,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 14,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: null,
    key: 'reports-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 15,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 16,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 36,
    featureId: null,
    key: 'aio-care-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 17,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: null,
    key: 'docvault-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 18,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 19,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 20,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 40,
    featureId: null,
    key: 'employee-payroll-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 21,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 41,
    featureId: null,
    key: 'order-form-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 22,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 23,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 1,
    key: 'business-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 24,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 1,
    key: 'business-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 25,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 1,
    key: 'business-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 26,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 2,
    key: 'restaurant-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 27,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 2,
    key: 'restaurant-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 28,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 2,
    key: 'restaurant-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 29,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 30,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 31,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 32,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 33,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 1,
    featureId: 3,
    key: 'bank-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 34,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 35,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 36,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 37,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 38,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 1,
    featureId: 4,
    key: 'credit-card-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 39,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 40,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 41,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 42,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 43,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 44,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 45,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 46,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 47,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 13,
    key: 'view-other-employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 48,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 13,
    key: 'view-other-employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 49,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 14,
    key: 'export-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 50,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 14,
    key: 'export-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 51,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 111,
    key: 'edit-time-entries-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 52,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 111,
    key: 'edit-time-entries-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 53,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 3,
    featureId: 111,
    key: 'edit-time-entries-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 54,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 55,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 56,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 112,
    key: 'view-other-employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 57,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 112,
    key: 'view-other-employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 58,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 59,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 60,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 113,
    key: 'approve-requests-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 61,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 114,
    key: 'request-tab-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 62,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 115,
    key: 'processed-tab-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 63,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 64,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 65,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 66,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 67,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 68,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 69,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 70,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 71,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 72,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 73,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 74,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 75,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 76,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 77,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 78,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 79,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 80,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 81,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 82,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 83,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 84,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 85,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 120,
    key: 'employees-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 86,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 87,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 88,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 7,
    featureId: 24,
    key: 'roles-permissions-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 89,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 8,
    featureId: 25,
    key: 'view-order-details-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 90,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 8,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 91,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 9,
    featureId: 27,
    key: 'share-job-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 92,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: 28,
    key: 'general-settings-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 93,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 10,
    featureId: 28,
    key: 'general-settings-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 94,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 10,
    featureId: 28,
    key: 'general-settings-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 95,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: 29,
    key: 'device-settings-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 96,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 10,
    featureId: 29,
    key: 'device-settings-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 97,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 10,
    featureId: 29,
    key: 'device-settings-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 98,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 10,
    featureId: 30,
    key: 'online-ordersing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 99,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 10,
    featureId: 30,
    key: 'online-ordersing-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 100,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 10,
    featureId: 30,
    key: 'online-ordersing-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 101,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 32,
    key: 'duplicate-shift-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 102,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 103,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 104,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 105,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 106,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 107,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 108,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 11,
    featureId: 117,
    key: 'shifts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 109,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 110,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 111,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 112,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 113,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 38,
    key: 'approve-requests-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 114,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 39,
    key: 'net-sales-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 115,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 40,
    key: 'labour-cost-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 116,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 41,
    key: 'comps-voids-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 117,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 42,
    key: 'top-sellers-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 118,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 13,
    featureId: 43,
    key: 'break-violations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 119,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 85,
    key: 're-assign-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 120,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 121,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 122,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 123,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 124,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 125,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 36,
    featureId: 87,
    key: 'p2p-chat-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 126,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 36,
    featureId: 88,
    key: 'approve-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 127,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 128,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 129,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 130,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 131,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 132,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 133,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 134,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 135,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 136,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 137,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 138,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 139,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 140,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 141,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 142,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 7,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 143,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 7,
    key: 'overview-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 144,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 8,
    key: 'staff-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 145,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 8,
    key: 'staff-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 146,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 9,
    key: 'office-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 147,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 9,
    key: 'office-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 148,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 10,
    key: 'marketing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 149,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 10,
    key: 'marketing-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 150,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 151,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 152,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 153,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 154,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 155,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 156,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 157,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 158,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 159,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 160,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 161,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 162,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 163,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 164,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 165,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 40,
    featureId: 128,
    key: 'pay-schedules-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 166,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 167,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 168,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 169,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 170,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 40,
    featureId: 129,
    key: 'payroll-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 171,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 41,
    featureId: 130,
    key: 'order-forms-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 172,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 131,
    key: 'view-others-pay-stubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1234,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1235,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1236,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1237,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1238,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1239,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: null,
    key: 'header-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1240,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1241,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: null,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1242,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1243,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1244,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1245,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1246,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1247,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 48,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1248,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 49,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1249,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 50,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1250,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1251,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1252,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1253,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1254,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1255,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1256,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1257,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1258,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1259,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1260,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1261,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1262,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1263,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1264,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 68,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1265,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 69,
    key: 'z-report-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1266,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1267,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 71,
    key: 'other-stations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1268,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1269,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'host-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1270,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1271,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1272,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1273,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1274,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1275,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1558,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1559,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1560,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1561,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1562,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1563,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1564,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 78,
    key: 'other-tables-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1565,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1566,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 79,
    key: 'void-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1567,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 80,
    key: 'edit-service-charge-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1568,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1569,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1570,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1571,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1572,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1573,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 81,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1670,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: null,
    featureId: null,
    key: 'web-dash-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1671,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1672,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: null,
    key: 'menu-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1673,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: null,
    key: 'marketing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1674,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1675,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1676,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1677,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1678,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1679,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1680,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1681,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1682,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1683,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1684,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1685,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1686,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1687,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1688,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1689,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1690,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1691,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1692,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1693,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1694,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1695,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1696,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1697,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1698,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1699,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1700,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1701,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1702,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1703,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1704,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1705,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1706,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1707,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1708,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1709,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1710,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1711,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1712,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1713,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1714,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1715,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1716,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1717,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1718,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1719,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1720,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1721,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1722,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1723,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1724,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1725,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1726,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1727,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1728,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1729,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1730,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1731,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1732,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1733,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1734,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1735,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1736,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1737,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1738,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1739,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1740,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1741,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1742,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1743,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1744,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1745,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1746,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1747,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1748,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1749,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1750,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1751,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1752,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1753,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1972,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 44,
    featureId: null,
    key: 'website-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1973,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1974,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1975,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1976,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 135,
    key: 'website-templates-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1977,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1978,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1979,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1980,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 136,
    key: 'website-builder-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1981,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1982,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1983,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1984,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 137,
    key: 'website-seo-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1985,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1986,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1987,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1988,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 44,
    featureId: 138,
    key: 'website-announcements-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1989,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1990,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1997,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1998,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2005,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 45,
    featureId: null,
    key: 'integrations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2009,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 45,
    featureId: null,
    key: 'integrations-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2013,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 141,
    key: 'review-management-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2014,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 141,
    key: 'review-management-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2254,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: null,
    key: 'inventory-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2340,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2341,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2342,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2343,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2344,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2345,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2346,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2347,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2348,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2349,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2350,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2351,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2352,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2353,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2354,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2355,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2356,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2357,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2358,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2359,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2360,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2361,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2362,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2363,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2364,
    roleId: 4,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2365,
    roleId: 4,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2366,
    roleId: 4,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2367,
    roleId: 4,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3478,
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const ownerDefaultPermissionForNewModules = [
  ...tenderCashDrawerFeatures,
  ...roleAndPermissionsModulePermissions,
  ...integrationModulePermissions,
  ...tipsPoolingModulePermissions,
  ...payrollModulePermissions,
  ...settingsModulePermission,
  ...reviewManagementFeaturePermission,
  ...visibleCheckPermissions,
];

export const ownerDefaultPosPermission = [
  tableLayoutPosModule['assign-server-visible'],
  orderHubPosModule['order-hub-visible'],
  orderHubPosModule['ticket-visible'],
  paymentPosModule['tenders-visible'],
];

export const ownerDefaultMenuBoardPermission = [...menuBoardPermission];
export const ownerCloseOutPermission = [dashboardPosModule['closeout-visible']];

export const ownerPosSettingsPermissions = [...settingsPosFeaturePermissions];
